import { useFormikContext } from 'formik';
import { getErrorMessage } from 'QuoteApp/utils';
import React, { FC } from 'react';
import NavigationPrompt from 'react-router-navigation-prompt';
import { useToast } from 'Shared/components';
import { Modal } from 'Shared/components/Modal';
import { SaveDiscardModal } from '../SaveDiscardModal';

type RoutePromptProps = {
  editingIdDisplay: string;
  when: boolean;
  isValid?: boolean;
};

export const RoutePrompt: FC<RoutePromptProps> = ({
  when,
  editingIdDisplay,
  isValid = true,
}) => {
  const { isSubmitting, submitForm } = useFormikContext();
  const { toast } = useToast();
  return (
    <NavigationPrompt when={when}>
      {({ onConfirm, onCancel }) => (
        <Modal showModal onClose={onCancel}>
          <SaveDiscardModal
            onSave={async () => {
              if (!isValid) {
                toast({
                  type: 'error',
                  message: 'Please fix validation errors before proceeding.',
                  withSecondaryNav: false,
                  icon: 'error',
                });
                onCancel();
              } else {
                try {
                  await submitForm();
                  onConfirm();
                } catch (e) {
                  onCancel();
                  toast({
                    type: 'error',
                    message: getErrorMessage(e),
                    withSecondaryNav: false,
                    icon: 'error',
                  });
                }
              }
            }}
            itemDisplay={editingIdDisplay}
            saveSubmitting={isSubmitting}
            onDiscard={() => {
              onConfirm();
            }}
          />
        </Modal>
      )}
    </NavigationPrompt>
  );
};
